// extracted by mini-css-extract-plugin
export default {"label":"Select_label__Skiu6","select":"Select_select__CawMq","hasError":"Select_hasError__eZSCc"};